import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit {

  @Input() errorMsg: string;
  errorCode: string;
  message: string;
  externalErrorMessage:string;

  constructor(private router: Router, private route:ActivatedRoute) {
  }

  ngOnInit() {
    // get the Error Code from ErrorMsg
    if (this.errorMsg) {
      this.setErrorMessage();
    } else {

      if (this.route.snapshot.queryParams['externalFlag'])
      {
        // this.message="Access to this resource currently unavailable. Please login again later.";
        this.externalErrorMessage = 'Access to this resource currently unavailable. Please login again later.';
      }
      else {
        this.message = 'An unexpected error occurred. Please try again later.';
      }
    }

  }

  private setErrorMessage() {
    if (this.errorMsg != null && typeof this.errorMsg === 'string') {
      this.errorCode = this.errorMsg.substring(0, 13).split(':')[1];
    }

    switch (this.errorCode) {
      case '400': {
        this.message = 'Bad Data. Invalid Input Parameters.';
        break;
      }
      case '404': {
        this.message = 'No search results to display, Close tab and go back to the search screen and try again.';
        break;
      }
      case '401': {
        this.message = 'You are not authorized to use this application.';
        break;
      }
      case '402': {
        this.message = 'You are not authorized to access this page';
        break;
      }
      case '403': {
        this.message = 'You do not have permission to access this page.';
        break;
      }
      case '500': {
        this.message = 'Please resubmit your request or contact Production Support.';
        break;
      }
      case '504': {
        this.message = 'An unexpected error occurred. Please try again later.';
        break;
      }
      case '503': {
        this.message = 'Service Unavailable. Please try again later.';
        break;
      }
      default: {
        this.message = 'An unexpected error occurred. Please try again later.';
        break;
      }
    }
  }
}


